/** @file numericRules: the one-line rules of the number-field grammar, shown by the Transform header's (i). */

/** One rule per line, in the order a user meets them. */
export const numericRules: readonly string[] = [
  '5 sets 5 and -5 sets -5.',
  '+5 adds 5; +-5 subtracts 5; += -= *= /= work too.',
  '*2 and /2 multiply and divide (/0 is refused).',
  'Formulas use + - * / ( ) and decimals: (1+2)/3.',
  'Enter or Tab commits; Esc restores the value.',
  'Up / Down step; Shift x10, Alt x0.1.',
  'Drag an axis letter to scrub (6 px per step); Esc cancels.',
];
